module.exports = __webpack_public_path__ + "b22426c0a5678b30d220d7340bd0d94c.MP3";